export enum Roles {
  INSPECTOR_ADMINISTRATOR = "ROLE_ORGANISATION_INSPECTOR_ADMINISTRATOR",
  ORGANISATION_ADMINISTRATOR = "ROLE_ORGANISATION_ADMINISTRATOR",
  ORGANISATION_INSPECTOR = "ROLE_ORGANISATION_INSPECTOR",
  ORGANISATION_CATCHREPORT_ADMINISTRATOR = "ROLE_ORGANISATION_CATCHREPORT_ADMINISTRATOR",
  ORGANISATION_GUESTCARD_ADMINISTRATOR = "ROLE_ORGANISATION_GUESTCARD_ADMINISTRATOR",
  ORGANISATION_MEMBER_LIST = "ROLE_ORGANISATION_MEMBER_LIST",
  ORGANISATION_MEMBERWORK_ADMINISTRATOR = "ROLE_ORGANISATION_MEMBERWORK_ADMINISTRATOR",
}
